import React, { Component } from 'react';
import { withTranslation } from '../../lib/translate';
import Basket from '../../lib/basket';
import { getConfig } from '../../appConfig';

class CheckoutPrebuildPayment extends Component {

    componentDidMount(){
            Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label)

    }
    render(){
        return <></>
    }
}
export default withTranslation(CheckoutPrebuildPayment);
